module.exports = __webpack_public_path__ + "static/cat-and-human-illustration-12ed6b98dc887eff711ae7bfee57cdd9.svg";